import React from 'react';
import Grid from '@material-ui/core/Grid';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import GavelIcon from '@material-ui/icons/Gavel';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import ReceiptIcon from '@material-ui/icons/Receipt';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { Section, SectionHeading, LinkCard } from '../Common/PageLayout';
import useSubdomainUrl from '../../subdomains/useSubdomainUrl';

const services = [
    {
        title: 'Budget and spending',
        description:
            'State Budget documents, execution reports and the transparency portals that show how public money is used.',
        icon: <AccountBalanceWalletIcon />,
        // The budget directorate's own site (address set in QuickServices below);
        // the /budgetspendingpage overview stays in the menu and footer.
        subdomain: 'budget',
        sameTab: true,
        cta: 'Visit budget.mof.gov.tl',
    },
    {
        title: 'Tenders and procurement',
        description:
            'Open tender notices, procurement rules and supplier registration through the national e-Procurement Portal.',
        icon: <GavelIcon />,
        to: '/tenders',
        cta: 'View tenders',
    },
    {
        title: 'Publications and reports',
        description:
            'Budget books, financial statements, treasury documents and other official Ministry publications.',
        icon: <MenuBookIcon />,
        to: '/publications',
        cta: 'Browse publications',
    },
    {
        title: 'Taxation',
        description:
            'Register, file and pay taxes with the Tax Authority of Timor-Leste, and read guidance for taxpayers.',
        icon: <ReceiptIcon />,
        href: 'https://attl.gov.tl/',
        cta: 'Tax Authority',
    },
    {
        title: 'Customs',
        description:
            'Import and export procedures, tariffs and clearance services provided by the Customs Authority.',
        icon: <LocalShippingIcon />,
        href: 'https://customs.gov.tl/',
        cta: 'Customs Authority',
    },
    {
        title: 'Statistics',
        description:
            'Official national statistics, census results and economic indicators published by INETL.',
        icon: <AssessmentIcon />,
        href: 'https://inetl-ip.gov.tl',
        cta: 'National statistics',
    },
];

/** Entry points to the Ministry's main services and to partner institutions. */
export default function QuickServices() {
    const siteUrl = useSubdomainUrl();
    return (
        <Section>
            <SectionHeading
                overline="Services"
                title="What we do"
                description="The Ministry of Finance plans the State Budget, manages the treasury, collects revenue and reports on public spending. Start with the services below."
                rule
            />
            <Grid container spacing={3}>
                {services.map(({ subdomain, ...service }) => (
                    <Grid item xs={12} sm={6} md={4} key={service.title}>
                        <LinkCard {...service} {...(subdomain ? { href: siteUrl(subdomain) } : {})} />
                    </Grid>
                ))}
            </Grid>
        </Section>
    );
}
